$(document).on('change', '#id_notification_delivery_time', function() {
  if ($(this).is(':checked')) {
    $('#id_notification_delivery_block').removeClass('hide');
  } else {
    $('#id_notification_delivery_block').addClass('hide');
    $('#id_notification_delivery_from option:first').attr('selected', 'selected');
    $('#id_notification_delivery_to option:first').attr('selected', 'selected');
  }
});
